import { CategoryFilterParentItemController } from './category-filter-parent-item.controller'

const component = {
  templateUrl: '/posts/components/category-filter-parent-item/category-filter-parent-item.html?$$REVISION$$',
  bindings: {
    categories: '<',
    isTopLevel: '<',
    onChange: '&',
    selectedCategory: '='
  },
  controllerAs: '$ctrl',
  controller: CategoryFilterParentItemController
}

export const categoryFilterParentItem = component
